/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.circle-user-filled\":\"Henkilö ympyrän sisällä\"}");